<template>
    <div>

        <modal
                class="abtg-modal"
                :width="800"
                height="auto"
                name="m-team">

            <div class="modal-dialog modal-lg abtg-modal-dialog" role="document">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title abtg__modal-title" id="exampleModalLabel2">
                            MEMBRO DEL TEAM</h5>

                        <div class="tools">
                            <div class="abtg__close-button"><a @click="closeModal()"><i
                                    class="fas fa-times"></i></a></div>

                        </div>
                    </div>


                    <div class="modal-body">

                        <form @submit.prevent="onSubmit()" class="">

                            <div class="row">
                                <div class="col-lg-6 col-xs-12">
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                                        <input class="mdl-textfield__input abtg__input" name="name"
                                               type="text"
                                               v-model="content.formData.name"

                                        >
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('team.name')}}</label>
                                        <p class="text-danger small" v-text="errors.get('name')"></p>
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xs-12">
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">

                                        <input class="mdl-textfield__input abtg__input" name="profession"
                                               type="text"
                                               v-model="content.formData.profession"

                                        >
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('team.profession')}}</label>
                                        <p class="text-danger small" v-text="errors.get('profession')"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-xs-12">
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                                        <input class="mdl-textfield__input abtg__input" name="email"
                                               type="text"
                                               v-model=" content.formData.email"
                                        >
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('team.email')}}</label>
                                        <p class="text-danger small" v-text="errors.get('email')"></p>
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xs-12">
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">

                                        <input class="mdl-textfield__input abtg__input" name="password"
                                               type="password"
                                               v-model="content.formData.password"
                                        >
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('team.password')}}</label>

                                        <p class="text-danger small" v-text="errors.get('password')"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">

                                        <input class="mdl-textfield__input abtg__input" name="phone"
                                               type="text"
                                               v-model="content.formData.phone"
                                        >
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('team.phone')}}</label>
                                        <p class="text-danger small" v-text="errors.get('phone')"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <button type="submit"
                                            class="  margin-right-10 btn-success float-right abtg__btn-star">

                                        {{$t('team.salva')}}
                                    </button>

                                </div>
                            </div>


                        </form>
                    </div>

                </div>
            </div>

        </modal>
    </div>


</template>
<script>

    import {mixin} from '@/helpers/helper'
    import DatePicker from 'vue2-datepicker';
    import {mapActions, mapState} from 'vuex';


    export default {
        props: ['content'],
        mixins: [mixin],
        components: {DatePicker},

        created() {
        },
        computed: {
            ...mapState('n_team', ['errors'])
        },
        methods: {
            ...mapActions('n_team', ['sendTeamData']),

            closeModal() {
                this.$emit('closeModal', 'm-team');
            },
            onSubmit() {
                this.sendTeamData(this.content.formData);
               // this.closeModal();
            }
        }
    }
</script>
